import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Utils/NewIcon';
import PatientUtils from 'services/PatientUtils';
import ConfirmationDialog from 'components/Utils/ConfirmationDialog';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';

const SendSMSIcon = (props) => {
  const dispatch = useAppDispatch();

  const [confirmation, setConfirmation] = useState(false);
  const [sending, setSending] = useState(false);

  async function onConfirmSend() {
    setSending(true);

    const { isSuccess } = await dispatch(
      api.Patients.sendSMS({ id: props.patient.id, stringResource: { value: props.message } }),
      {
        errorTitle: 'Send SMS',
        meta: true,
      },
    );

    setConfirmation(false);
    setSending(false);

    if (isSuccess && props.onSuccess) props.onSuccess();
  }

  function onCancelSend() {
    setSending(false);
    setConfirmation(false);
  }

  return (
    <>
      {confirmation && (
        <ConfirmationDialog
          title="Do you want to send an SMS?"
          open={confirmation}
          message={`This will send the following SMS to ${PatientUtils.getName(props.patient)}: "${
            props.message
          }"`}
          onConfirm={onConfirmSend}
          onCancel={onCancelSend}
          loadingState={sending}
        />
      )}
      <Icon
        alt="Send SMS Message"
        showTooltip={true}
        width="20px"
        src="message-sms"
        className="icon-sms"
        onClick={() => setConfirmation(true)}
      />
    </>
  );
};

SendSMSIcon.propTypes = {
  patient: PropTypes.object.isRequired,
  message: PropTypes.string,
  onSuccess: PropTypes.func,
};

export default SendSMSIcon;
